import React from 'react'

const Chat = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => (
    <svg
        width="46"
        height="39"
        viewBox="0 0 46 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        {...props}
    >
        <path
            d="M24.5339 11.8331C24.4304 9.88174 23.8445 7.98841 22.8305 6.32799C21.8166 4.66757 20.4071 3.29362 18.7325 2.33306C12.4733 -1.09718 4.0973 1.28654 2.1406 8.64701C1.5468 10.8276 1.57856 13.1353 2.23214 15.2982C2.39517 15.9035 2.5062 16.5221 2.56398 17.147C2.8386 19.4726 0.275442 22.8098 0.893347 23.4726C1.06499 23.9261 7.34701 20.6819 7.83905 20.7865C8.98332 21.0075 10.0246 21.5656 11.1231 21.8796C12.8849 22.4304 14.7443 22.5812 16.5698 22.3214C18.3683 22.0874 20.0451 21.2721 21.3528 19.9958C22.4939 18.566 23.5485 17.0671 24.511 15.5075C26.0616 13.163 28.4283 11.5022 31.1351 10.8593C33.8419 10.2164 36.6879 10.6391 39.1004 12.0424C43.174 14.5656 45.5655 18.5889 44.2611 23.9726C43.908 25.4874 43.2666 26.9174 42.373 28.1819C41.5148 29.3447 40.6223 30.2051 40.5651 31.7749C40.5651 32.9958 41.2059 37.6703 40.5651 38.0424C39.6268 38.6121 36.4915 34.3098 35.4273 33.3912C32.6577 33.7271 29.8544 33.1655 27.4175 31.7865C24.665 29.9628 22.6378 27.2065 21.6961 24.0075"
            stroke="#686058"
            strokeWidth="1.59375"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default Chat
